import React, { useEffect, useState } from "react";
import useRefreshToken from "../../../../../Hooks/usegenerateToken";
import { BASE_URL, GET_ALL_VERIFICATION_REQ, GLOBAL_REQUESTS, USER_TOKEN } from "../../../../../Utils/constant";
import TopTitleBar from "../../TopTitleBar";
import API from '../../../../../ApiConfig'
import Icon from "react-icons-kit";
import { useSelector } from "react-redux";
import Loader from "../../../../../components/Loader";
import Pagination from "../../Pagination";
import SlideUpWrapper from "../../../../../components/Transitions/SlideUpWrapper";
import { useParams } from "react-router-dom";
import Records from "../../../../../components/Verifier/Records";
import cogoToast from "cogo-toast-react-17-fix";
import NavLinks from "../../../../../components/NavLinks";



export default function MyRequests({ id }) {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const [search, setSearch] = useState('')
    const User = useSelector(state => state.User)
    const [list, setList] = useState([])
    const [apiData, setApiData] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)


    // Tabs
    const [MenuLinks, setMenuLinks] = useState([
        { name: "All Requests", link: "", subText: '0' },
        { name: "Complete", link: "DRAFT", subText: '0' },
        { name: "Pending", link: "PUBLISHED", subText: '0' }
    ])
    const [activeTab, setActiveTab] = useState({ name: "All Credentials", link: "" })


    function handleActiveTab(e) {
        setActiveTab(e)
    }

    useEffect(() => {
        if (activeTab.link == "") {
            setList(apiData);
        }
        else {
            let lst = apiData.filter(e => {
                return e.status == activeTab.name;
            })
            setList(lst);
        }
    }, [activeTab])

    useEffect(() => {
        const delayDebounce=setTimeout(()=>{
            getVerificationList()
      
          },500)
          return ()=>clearTimeout(delayDebounce)
    }, [currentPage, search])

    // useEffect(()=>{
    //   window.setTimeout( function() {
    //     window.location.reload();
    //   }, 10000)
    // },[])


    async function getVerificationList() {

        const setmenucount = (data) => {
            let pending = data.filter(e => { return e.status == 'Pending'; }).length
            setMenuLinks([
                { name: "All Requests", link: "", subText: data.length },
                { name: "Complete", link: "DRAFT", subText: data.length - pending },
                { name: "Pending", link: "PUBLISHED", subText: pending }
            ])
        }

        setLoading(true)
        API.get(GLOBAL_REQUESTS , {
            params: {
                page: currentPage,
                verifier_company_id:User.company_id,
                search:search,
                limit:10
            }
        })
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    let { data } = res.data
                    setList(data.items)
                    setApiData(data.items)
                    // setmenucount(data)
                    setCurrentPage(data.current_page)
                    setTotalPages(data.total_pages)
                }
            })
            .catch(err => {
                // console.log(err)
                setLoading(false)
                cogoToast.error(err.response.data.detail)
            })
    }
    // function handleSearch(value) {
    //     if (value.length === 0) 
    //         setList(apiData)
    //     else {
    //         let result = []
    //         {
    //             apiData.map(apiItem => {
    //                 const formUuid = Object.keys(apiItem)[0]
    //                 const formData = apiItem[formUuid];
    //                 let temp = formData.filter(item => (item.form_name.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || (moment.utc(item.data_submission_date).format('DD MMM YYYY').toLocaleLowerCase().includes(value.toLocaleLowerCase()))
    //                 ))
    //                 if (temp.length > 0) result.push({ [formUuid]: temp });
    //             })
    //         }

    //         setList(result)
    //     }
    //     setSearch(value)

    // }

    function handleSearch(value) {
        setSearch(value)
        setCurrentPage(1)
    }

    const handlePageChange = (nextPage) => {
        setCurrentPage(nextPage);
    }
    return (
        <div style={{width:"100%"}}>
        <SlideUpWrapper direction='slide-left'>

            <TopTitleBar isChild >
                <h2 className="topTitleBarText"> <span className="secondaryButton1">My Requests</span></h2>
            </TopTitleBar>
            <Loader isOpen={loading} />
            {/* <div className="navLinksContainer">
                <NavLinks loading={loading} MenuLinks={MenuLinks} menuClick={handleActiveTab} />
            </div> */}
            <section className="table-header6" style={{ justifyContent: "space-between" }}>
                <div className="inputField2">
                    <div className="input1">
                        <div className="content1">
                            <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
                            <input value={search} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
                        </div>
                    </div>
                </div>
                {/* <div className='refreshLoader'>
                    <div className='primaryBtn' title='Reload Table' onClick={handleRefresh} style={{ marginLeft: "1rem", display: "flex", alignItems: "center" }}>
                        <div className={loading ? 'reloadIcon1' : 'reloadIcon'}><Icon icon={reload} size={15} /></div> <span style={{ marginLeft: "7px", fontSize: "12px" }}> Refresh </span> </div>
                </div> */}
            </section>
            <div className="credentials-table">

                <Records data={list} Loading={loading} />
                <div style={{ margin: "10px" }}>
                    <Pagination
                        nPages={totalPages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        onPageChange={handlePageChange}
                        loading={loading}
                    />
                </div>
            </div>
        </SlideUpWrapper>
        </div>
    )
}
